/**
 * @typedef {Object} LightboxType
 * @property {string} pdf_preview - The PDF preview lightbox type.
 * @property {string} file_manager - The file manager lightbox type.
 * @property {string} bukku_upload - The bukku upload lightbox type.
 * @property {string} TRANSACTION - The transaction lightbox type (list and view).
 * @property {string} CONTACT - The contact lightbox type (list and view)
 */

export const LightboxType = {
    pdf_preview: 'pdf_preview',
    file_manager: 'file_manager',
    bukku_upload: 'bukku_upload',

    TRANSACTION: 'TRANSACTION',
    CONTACT: 'CONTACT',
};
